<main>
  <h2>Dumpcast is the official Dumpster Fire podcast! <ion-icon class="share-button" name="share-outline" size="large" on:click={() => {
    navigator.share({
      title: "Dumpster Fire - Dumpcast",
      url: location.href
    });
  }}/></h2>
  <br>
  <iframe title="Dumpcast" seamless src="/dumpcast-iframe.html" frameborder="0" width="100%" height="1000em"></iframe>
  <!-- <h2>Apple Podcasts</h2>
  <iframe
    title="Apple Podcasts"
    src="https://embed.podcasts.apple.com/us/podcast/dumpcast/id1561702231?itsct=podcast_box&amp;itscg=30200&amp;theme=auto"
    sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-top-navigation-by-user-activation"
    allow="autoplay *; encrypted-media *;"
    style="width: 100%; max-width: 660px; overflow: hidden; border-radius: 10px; background: transparent none repeat scroll 0% 0%;"
    height="450px"
    frameborder="0"
    loading="lazy"
  />
  <h2>Spotify</h2>
  <iframe
    title="Spotify"
    src="https://open.spotify.com/embed-podcast/show/6nwxv5tesruZz7uDy16P5w"
    width="100%"
    height="232"
    frameborder="0"
    allowtransparency="true"
    allow="encrypted-media"
    loading="lazy"
  />
  <h2>YouTube</h2>
  <iframe
    width="100%"
    height="315"
    src="https://www.youtube.com/embed/videoseries?list=PLQQid_u7G2GiIHLtffDieDEkdkiPRVrNd"
    title="YouTube video player"
    frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    allowfullscreen
    loading="lazy"
  />
  <h2>SoundCloud</h2>
  <iframe
    title="SoundCloud"
    width="100%"
    height="300"
    scrolling="no"
    frameborder="no"
    allow="autoplay"
    src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/1049444974&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true"
    loading="lazy"
  />
  <div
    style="font-size: 10px; color: #cccccc;line-break: anywhere;word-break: normal;overflow: hidden;white-space: nowrap;text-overflow: ellipsis; font-family: Interstate,Lucida Grande,Lucida Sans Unicode,Lucida Sans,Garuda,Verdana,Tahoma,sans-serif;font-weight: 100;"
  >
    <a
      href="https://soundcloud.com/user-736900638"
      title="dumpsterfiremusic"
      target="_blank"
      style="color: #cccccc; text-decoration: none;">dumpsterfiremusic</a
    >
    ·
    <a
      href="https://soundcloud.com/user-736900638/sets/dumpcast"
      title="Dumpcast"
      target="_blank"
      style="color: #cccccc; text-decoration: none;">Dumpcast</a
    >
  </div>

  <h3>
    We also have an <a
      href="https://feeds.soundcloud.com/users/soundcloud:users:784452757/sounds.rss"
      >RSS feed</a
    >
  </h3> -->
  <!-- <br /> -->
  <h3>If you're interested in applying for Dumpcast...</h3>
  <p>You can do so with the form below:</p>
  <a href="/dumpcastform.pdf">Dumpcast Registration Form</a>
</main>
